import { X } from 'lucide-react'
import { AlertDialog, AlertDialogContent } from '@/components/ui/alert-dialog'

export function BottomSheet({
  open,
  onClose,
  title,
  children,
  footer,
}: {
  open: boolean
  onClose: () => void
  title: string
  children: React.ReactNode
  footer: React.ReactNode
}) {
  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent className="left-1/2 -translate-x-1/2 max-w-[1024px] !rounded-t-[36px] !rounded-b-none top-[unset] fixed bottom-0 z-[51] gap-6 bg-[#2F2F32] border-0 px-5 pt-8 pb-6">
        {/* Header */}
        <h2 className="font-figtree font-semibold leading-[22px] text-white text-[20px] w-full mb-2 text-center">
          {title}
        </h2>

        {/* Close icon */}
        <button
          onClick={onClose}
          className="absolute top-7 right-5 rounded-full flex items-center justify-center w-[32px] h-[32px]"
        >
          <X className='text-white' />
        </button>

        {/* Body */}
        <div className="flex flex-col gap-6">
          {children}
        </div>

        {/* Footer */}
        <div className="flex flex-col gap-2">
          {footer}
        </div>
      </AlertDialogContent>
    </AlertDialog>
  )
}
